import { useEffect } from 'react';
import
{
    Dialog, DialogContent,
    DialogActions,
    Divider,
    Typography,
    Button,
} from '@mui/material';
import
{
    Cancel as CancelIcon,
    ArrowForwardIos as ArrowForwardIcon
} from "@mui/icons-material";
import CustomDialogTitle from "../CustomDialogTitle";
import { useTranslation } from 'react-i18next';
const WarningDialog = ({
    isOpen,
    onClose,
    onSubmit,
    cancelButtonText,
    actionButtonText,
    actionButtonIcon,
    title,
    message,
    color
}) =>
{
    const { t } = useTranslation();

    useEffect(() => {
        if (!isOpen) return;
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
    }, [isOpen]);

    const handleOnSubmit = (e) =>
    {
        e.preventDefault();
        onSubmit();
        onClose();
    }
    return (
        <Dialog
            sx={{ zIndex: Number.MAX_VALUE }}
            component="form"
            onSubmit={handleOnSubmit}
            open={isOpen}
            onClose={onClose}
            maxWidth="sm"
            fullWidth={true}
            disableRestoreFocus
        >      <CustomDialogTitle
                title={title ? title : t("warning")}
                onClose={onClose}
                type={color ? color : "error"}
            />
            <Divider />
            <DialogContent>
                <Typography variant="body1" component="div">
                    {message == null ? t("this_action_cannot_take_back") : message}
                </Typography>
            </DialogContent>
            <Divider />
            <DialogActions sx={{ padding: 2 }}>
                {onSubmit && (
                    <Button
                        startIcon={
                            actionButtonIcon ? actionButtonIcon : <ArrowForwardIcon />
                        }
                        type="submit"
                        name="submit"
                        variant="contained"
                        color={color ? color : "error"}
                        autoFocus
                    >
                        {actionButtonText ? actionButtonText : t("continue")}
                    </Button>
                )}
                <Button
                    startIcon={<CancelIcon />}
                    onClick={onClose}
                    name="cancel"
                    variant="contained"
                    color="info"
                >
                    {cancelButtonText ? cancelButtonText : t("cancel")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default WarningDialog